// PREVENT NEGATIVE VALUE 
export function  preventNegativeInput(event) {
  if (['-', 'e', 'E', '+'].includes(event.key)) {
    event.preventDefault();
    return;
  }

  if (event.key === 'ArrowDown' && Number(event.target.value) <= 0) {
    event.preventDefault();
    event.target.value = 0;
    return;
  }
}

export const limitMaxTen = (e) => {
  const { value } = e.target;

  if (['-', 'e', '+'].includes(e.key)) {
    e.preventDefault();
    return;
  }

  if (e.key === 'ArrowDown' && Number(value) <= 0) {
    e.preventDefault();
    return;
  }

  if (e.key === 'ArrowUp' && Number(value) >= 10) {
    e.preventDefault();
    return;
  }

  if (
    ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key)
  ) {
    return;
  }

  const nextValue = Number(value + e.key);
  if (!isNaN(nextValue) && nextValue > 10) {
    e.preventDefault();
  }

  setTimeout(() => {
    let current = Number(e.target.value);
    if (current < 0) current = 0;
    if (current > 10) current = 10;
    e.target.value = current;
    e.target.dispatchEvent(
      new Event('input', { bubbles: true })
    );
  }, 0);
};


export const validateNumber = (e) => {

};